/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_MAP_MARKER': {
    width: 16,
    height: 16,
    viewBox: '0 0 21.5 30',
    data: '<path pid="0" d="M10.714 30C3.571 21.088 0 14.66 0 10.714 0 4.797 4.797 0 10.714 0 16.632 0 21.43 4.797 21.43 10.714c0 3.945-3.572 10.374-10.715 19.286zM11 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" _fill="#F56225" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_MAP_MARKER.js